import React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

interface LoadingProps {
  loading: boolean
  children: React.ReactNode | (() => React.ReactNode)
  skeleton?: React.ReactNode
}

const Loading: React.FC<LoadingProps> = ({ loading, skeleton, children }) => {
  return loading ? (
    <Box alignItems="center" justifyContent="center" flexGrow>
      {skeleton ? skeleton : <Spinner />}
    </Box>
  ) : (
    <>{typeof children === 'function' ? children() : children}</>
  )
}

export default Loading
